import type { ComponentProps } from 'react';
import type { EQuestionType } from '@hubertai/screening-question-types';
import { useTranslation } from 'react-i18next';
import MutedText from 'components/common/MutedText';

const typeToKey = (type: string) => type.replace(/[-_]([a-z])/g, (_, c: string) => c.toUpperCase());

interface Props extends ComponentProps<'div'> {
  type: EQuestionType;
}

const QuestionTypeDescription = ({ type, ...props }: Props) => {
  const { t } = useTranslation('Questionsv2');

  if (!type) return null;

  const title = t(`questionTypes.labels.${typeToKey(type)}`);
  const description = t(`questionTypes.descriptions.${typeToKey(type)}`);

  if (!title || !description) return null;

  return (
    <div {...props}>
      <MutedText className="flex items-center gap-2">{description}</MutedText>
    </div>
  );
};

export default QuestionTypeDescription;
